var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPkt1SvGwhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 52,
    viewBox: "0 0 162 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 51.2222H10V37.2222C10 37.2222 19.5 37.7222 24 37.2222C28.5 36.7222 30.2599 35.2911 33 32.7222C34.6242 31.1995 35.4064 30.1614 36.5 28.2222C38.3844 24.8806 38.9526 22.5582 39 18.7222C39.0497 14.6971 38.478 12.2281 36.5 8.72222C35.406 6.78321 34.6541 5.71235 33 4.22222C30.2743 1.7667 27.6462 0.627339 24 0.222216C19.5 -0.277771 0 0.222216 0 0.222216V51.2222ZM11 11.2222V26.2222H19C19 26.2222 23.984 26.1592 26 24.2222C27.7811 22.511 28 21.1921 28 18.7222C28 16.2523 27.7811 14.9334 26 13.2222C23.984 11.2853 19 11.2222 19 11.2222H11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136 0.222229H94.5V10.2222H109.5V50.7222H120V10.2222H136V0.222229Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47.2222V31.7222L75.5 0.222229H91L68 22.7222L90.5 50.7222H77L60.5 30.7222L44 47.2222Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 50.7222H161.5V0.222229H152L140 11.7222L146.5 18.2222L152.5 12.2222V50.7222Z",
    fill: "#3BAF2A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44 0.222229H63L44 19.2222V0.222229Z",
    fill: "#3BAF2A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkt1SvGwhite);
export default __webpack_public_path__ + "static/media/PKT1 SVG white.d1458ab7f8d112008aa5a650e7e515fe.svg";
export { ForwardRef as ReactComponent };